import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MenuContext, MenuContextType } from "../../context/MenuContext";
import { app } from "../../signals/AppSignal";
import { useSignal, useSignalEffect } from "@preact/signals-react";

const Menubar = () => {
  useSignal(0);
  const { toggle, setMenuToggle } = useContext(MenuContext) as MenuContextType;
  const location = useLocation();

  const [appName, setAppName] = useState(app.value)

  const getBreadcrumbs = () => {
    const path: Array<string> = location.pathname.split("/");
    let namelist = path.map((name, index) => {
      return (
        <li key={index} className="breadcrumb-item text-sm">
          {name.toLowerCase()}
        </li>
      );
    });
    return (
      <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        &nbsp;&nbsp;&nbsp; {namelist}
      </ol>
    );
  };

  const handleToggle = () => {
    setMenuToggle(toggle ? false : true);
  };
  
  useSignalEffect(()=> {
    setAppName(app.value);
  })

  useEffect(() => {
    if (toggle) {
      document.body.classList.add("g-sidenav-pinned");
    } else {
      document.body.classList.remove("g-sidenav-pinned");
    }
  }, [toggle]);

  return (
    <nav
      className="navbar navbar-main navbar-expand-lg position-sticky mt-2 top-1 px-0 py-1 mx-3 shadow-none border-radius-lg z-index-sticky"
      id="navbarBlur"
      data-scroll="true"
    >
      <div className="container-fluid py-1 px-2">
        <div className="sidenav-toggler sidenav-toggler-inner d-xl-block d-none ">
          <a href="#" className="nav-link text-body p-0">
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
              <i className="sidenav-toggler-line"></i>
            </div>
          </a>
        </div>
        <nav aria-label="breadcrumb">{getBreadcrumbs()}</nav>
        <div
          className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4"
          id="navbar"
        >
          <div className="ms-md-auto pe-md-3 d-flex align-items-center">
            &nbsp;
          </div>
          <div className="ms-md-auto pe-md-3 d-flex align-items-center">
            <div className="input-group input-group-outline">
              <select
                className="form-control"
                value={appName}
                onChange={(e) => (app.value = e.currentTarget.value)}
              >
                <option value={"qrit"}>QR Item Tracker</option>
                <option value={"stp"}>Shipment Tracker Pro</option>
              </select>
            </div>
          </div>
          <ul className="navbar-nav  justify-content-end">
            <li className="nav-item">
              <a href="#" className="px-1 py-0 nav-link line-height-0">
                <i className="material-symbols-rounded">account_circle</i>
              </a>
            </li>
            <li className="nav-item dropdown py-0">
              <a
                href="#"
                className="nav-link py-0 px-1 position-relative line-height-0"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-symbols-rounded fixed-plugin-button-nav">
                  settings
                </i>
              </a>
              <ul
                className="dropdown-menu dropdown-menu-end p-2 me-sm-n4"
                aria-labelledby="dropdownMenuButton"
              >
                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex align-items-center py-1">
                      <span className="material-symbols-rounded">email</span>
                      <div className="ms-2">
                        <h6 className="text-sm font-weight-normal my-auto">
                          Check new messages
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>
                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex align-items-center py-1">
                      <span className="material-symbols-rounded">podcasts</span>
                      <div className="ms-2">
                        <h6 className="text-sm font-weight-normal my-auto">
                          Manage podcast session
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex align-items-center py-1">
                      <span className="material-symbols-rounded">
                        shopping_cart
                      </span>
                      <div className="ms-2">
                        <h6 className="text-sm font-weight-normal my-auto">
                          Payment successfully completed
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown py-0 pe-3">
              <a
                href="#"
                className="nav-link py-0 px-1 position-relative line-height-0"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-symbols-rounded">notifications</i>
                <span className="position-absolute top-5 start-100 translate-middle badge rounded-pill bg-danger border border-white small py-1 px-2">
                  <span className="small">11</span>
                  <span className="visually-hidden">unread notifications</span>
                </span>
              </a>
              <ul
                className="dropdown-menu dropdown-menu-end p-2 me-sm-n4"
                aria-labelledby="dropdownMenuButton"
              >
                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex align-items-center py-1">
                      <span className="material-symbols-rounded">email</span>
                      <div className="ms-2">
                        <h6 className="text-sm font-weight-normal my-auto">
                          Check new messages
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>
                <li className="mb-2">
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex align-items-center py-1">
                      <span className="material-symbols-rounded">podcasts</span>
                      <div className="ms-2">
                        <h6 className="text-sm font-weight-normal my-auto">
                          Manage podcast session
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item border-radius-md" href="#">
                    <div className="d-flex align-items-center py-1">
                      <span className="material-symbols-rounded">
                        shopping_cart
                      </span>
                      <div className="ms-2">
                        <h6 className="text-sm font-weight-normal my-auto">
                          Payment successfully completed
                        </h6>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </li>

            <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
              <a
                href="#"
                className="nav-link text-body p-0"
                id="iconNavbarSidenav"
                onClick={handleToggle}
              >
                <div className="sidenav-toggler-inner">
                  <i className="sidenav-toggler-line"></i>
                  <i className="sidenav-toggler-line"></i>
                  <i className="sidenav-toggler-line"></i>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Menubar;
